import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var RepeatPipe = (function () {
    function RepeatPipe() {
    }
    RepeatPipe.prototype.transform = function (input, times, characters) {
        if (times === void 0) { times = 1; }
        if (characters === void 0) { characters = ''; }
        if (!isString(input)) {
            return input;
        }
        if (times <= 0) {
            times = 1;
        }
        var repeated = [input];
        for (var i = 1; i < times; ++i) {
            repeated.push(input);
        }
        return repeated.join(characters);
    };
    return RepeatPipe;
}());
export { RepeatPipe };
RepeatPipe.decorators = [
    { type: Pipe, args: [{
                name: 'repeat'
            },] },
];
/** @nocollapse */
RepeatPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=repeat.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/repeat.pipe.js
// module id = 284
// module chunks = 103